import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function BasicDeail({
  formData,
  setFormData,
  formErrors,
  setFormErrors,
}) {
  const handleOnChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [field]: '',
    }));
  };

  return (
    <div className="div-flex-column rg-10 horizontal-padding-10">
      <div className="div-flex-column rg-20 padding-top-8 padding-bottom-13">
        <Row className="g-3 div-align-center">
          <Col xxl={4} xl={4} lg={4}>
            <span className="text-sm text-semi-bold">Quality Check Name</span>
            <span className="text-red">&nbsp;*</span>
            <input
              className={`${formErrors?.qualityCheckName ? 'form-input-error' : 'form-input-section'}`}
              name="qualityCheckName"
              placeholder="Input Name"
              value={formData.qualityCheckName}
              onChange={(e) =>
                handleOnChange('qualityCheckName', e.target.value)
              }
            />
          </Col>

          <Col xxl={6} xl={6} lg={6}>
            <span className="text-sm text-semi-bold">Description</span>
            <span className="text-red">&nbsp;*</span>
            <input
              className={`${formErrors?.description ? 'form-input-error' : 'form-input-section'}`}
              name="description"
              placeholder="Input Description"
              value={formData.description}
              onChange={(e) => handleOnChange('description', e.target.value)}
            />
          </Col>
          <Col xxl={2} xl={2} lg={2}>
            <div className="padding-top-10">
              <div className="div-flex-row div-align-center cg-10 padding-top-10">
                <span className="text-md text-semi-bold">Active</span>
                <label className="toggle" htmlFor="qcToggleTrue">
                  <input
                    id="qcToggleTrue"
                    type="checkbox"
                    aria-label="toggle true"
                    checked={formData.isActive}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        isActive: e.target.checked,
                      }))
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
